<template>
  <div class="mainHead">
    <div class="head">
      <div class="headLeft" @click="toHome()">
        <!-- <img src="./../assets/headlogo.png" alt="" /> -->
        <div>MTNFT区块链浏览器</div>
      </div>
      <div class="headRight">
        <el-dropdown>
          <div
            style="
              color: black;
              margin-right: 10px;
              height: 35px;
              line-height: 35px;
            "
          >
            {{ type }}<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in list"
              :key="index"
              @click.native="dropdowns(item)"
              >{{ item }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-input
          :placeholder="placeholder"
          v-model="inputValue"
          class="elInput"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search()"
            style="background-color: #dbdeed"
          ></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputValue: "",
      list: ["存证编号", "交易哈希", "用户地址", "合约地址"],
      placeholder: "",
      type: "",
    };
  },
  created() {
    this.getPlaceholder();
  },
  methods: {
    toHome() {
      this.$router.push({
        name: "home",
      });
    },
    getPlaceholder() {
      this.placeholder = "请输入" + this.list[0];
      this.type = this.list[0];
    },
    dropdowns(item) {
      this.placeholder = "请输入" + item;
      this.type = item;
    },
    search() {
      if (this.inputValue) {
        if (this.type == "交易哈希") {
          if (this.inputValue) {
            this.$router.push({
              path: "/hash-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "存证编号") {
          if (this.inputValue) {
            this.$router.push({
              path: "/evidence-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "合约地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/contract-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "用户地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/user-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mainHead {
  height: 70px;
  background-color: #fefeff;
  width: 100%;
  /*position: fixed;*/
  /*z-index: 1;*/
  /*top: 0;*/
  .head {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 1200px;
    .headLeft {
      cursor: pointer;
      display: flex;
      margin-top: 20px;
      img {
        width: 30px;
        height: 30px;
      }
      div {
        font-size: 16px;
        font-weight: bolder;
        margin-left: 10px;
        line-height: 30px;
        font-family: "黑体";
        /*color: #1270b9;*/
        color: rgb(44, 37, 37);
      }
    }
    .headRight {
      margin-top: 15px;
      /deep/ .el-input-group > .el-input__inner {
        background-color: #f1f1f1;
        font-size: 18px;
        font-family: Source Han Sans CN-Light, Source Han Sans CN;
        font-weight: 300;
        color: #888888;
      }
      /deep/ .el-input__inner {
        border-color: transparent;
      }
      .el-input-group__append .el-button{
        height: 48px;
      }
      .el-button{
        padding: 10px;
      }
      .elInput {
        width: 270px;
        height: 48px;
        background: #f1f1f1;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
      }
     /deep/ .el-icon-search:before {
        font-size: 28px;
      }
    }
  }
}
</style>
